/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import BarChartIcon from '@mui/icons-material/BarChart'
import ForwardIcon from '@mui/icons-material/Forward'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import IconButton from '@mui/material/IconButton'
import EditIcon from '@mui/icons-material/Edit'

import { standardSpinner } from '../../../helpers/spinners'

import { Input, dummyBox, validEmail } from '../../../helpers/globalHelpers'
import { positionChangeHeightSm, positionChangeWidthSm, positionChangeWidthMd } from '../../../helpers/variableDefaults'
import useWindowDimensions from '../../../helpers/windowDimensions'
import { personItemTextField } from '../../../helpers/textfields'
import { selectElement } from '../../../helpers/selects'
import { getTokenFromLocalStorage } from '../../../helpers/storage'
import { returnVideoThumbnailFromLiveURL, returnDurationFromLiveURL } from '../../../helpers/imageHandling'
import { handleSetVideoThumbnailMediaItem } from '../../../helpers/commonMethods'

// Media Instance
const MediaInstance = (props) => {
  
  // Navigate
  const navigate = useNavigate()
  
  // Destructure Props
  const { mediaItem, mediaItemIndex, user, fromComponent, loadingNewMedia, newMediaArray, isDemo } = props
  // console.log('profile ->', profile)
  // console.log('fromComponent ->', fromComponent)

  // Window Dimensions
  const { height, width } = useWindowDimensions()

  const handleEdit = async (e) => {
    // console.log('handleEdit runs')
    if (!isDemo) {
      navigate(`/media-item/${mediaItem._id}/${mediaItem.userId}`)
    }
  }

  const [videoDuration, setVideoDuration] = useState(-1)
  const [videoThumbnail, setVideoThumbnail] = useState('')
  
  useEffect(() => {
    const getData = async () => {
      if (mediaItem.type === 'video') {
        await handleSetVideoThumbnailMediaItem(mediaItem, setVideoThumbnail, setVideoDuration)
      }
    }

    getData()
    
  }, [])
  
  useEffect(() => {
    // console.log('videoThumbnail useEffect runs')

  }, [videoThumbnail])

  // Edit Icon Button JSX
  const editItemIconJSX = () => {
    return (
      <Box
        sx={{
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-end',
        }}
      >
        <IconButton
          onClick={handleEdit} 
          disabled={loadingNewMedia || newMediaArray.length > 0}
          sx={{ 
            backgroundColor: 'white',
            '&:hover': {
              backgroundColor: 'black',
            },
            width: '30px', height: '30px', 
            mb: 1, mt: 1, mr: 1, ml: 1, bottom: 0, left: 0, 
            border: 0, borderColor: 'white', boxShadow: 2, 
          }} 
        >
          <EditIcon 
            fontSize="small" 
            color="primary"
            sx={{ 

            }} 
          />
        </IconButton>
      </Box>
    )
  }
  
  return (
    <>
      {/* This must be first input So that the file upload only fires when you press the button */}
      <Box sx={{ width: '100%' }}>
        <Input type="text" autoFocus="autoFocus" />
      </Box>
      
      {/* Media Item */}
      <Box 
        sx={{ 
          my: 1,
          width: width < positionChangeWidthSm ? '200px' : '150px',
          height: width < positionChangeWidthSm ? '200px' : '150px',
          backgroundImage: mediaItem.type === 'video' ? `url(${videoThumbnail !== null ? videoThumbnail : ''})` : `url(${mediaItem.url})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          boxShadow: 3, 
          borderRadius: '5px', 
          display: 'flex', flexDirection: 'column', justifyContent: mediaItem.type === 'video' ? 'space-between' : 'flex-start', alignItems: 'flex-end', 
        }}
      >
        {/* {console.log('videoThumbnail ->', videoThumbnail)} */}
        {editItemIconJSX()}
        {mediaItem.type === 'video' && videoDuration >= 0 &&
          <Box
            sx={{
              my: 1, mx: 1,
              backgroundColor: 'white',
              opacity: 0.8,
              fontSize: '14px',
              width: '30px', maxWidth: '30px',
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
            }}
          >
            {videoDuration}s
          </Box>
        }
        
      </Box>
    </>
  )
}

export default MediaInstance